import { PartnerGroupRules, useGroupRules, UserGroupRules } from 'src/graphql';

interface MembershipsPermissions {
  loading: boolean;
  canEditMembershipsConfig: boolean;
  canManageLandingPages: boolean;
  canManageLandingPageDomains: boolean;
}

export const useMembershipsPermissions = (): MembershipsPermissions => {
  const { checkValidity, loading } = useGroupRules();

  return {
    loading,
    canEditMembershipsConfig:
      !loading && checkValidity([UserGroupRules.AccessToConfigureMemberships]),
    canManageLandingPages:
      !loading &&
      checkValidity(
        [PartnerGroupRules.AccessToLandingPages, UserGroupRules.AccessToManageLandingPages],
        { matchType: 'all' },
      ),
    canManageLandingPageDomains:
      !loading &&
      checkValidity(
        [
          PartnerGroupRules.AccessToLandingPages,
          UserGroupRules.AccessToManageLandingPages,
          UserGroupRules.AccessToManageLandingPageDomains,
        ],
        { matchType: 'all' },
      ),
  };
};
